import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getFaqDynamicAnswers } from 'site-modules/lease-deals/utils/get-faq-dynamic-answers';
import { interpolateTemplate } from 'site-modules/lease-deals/utils/interpolate-template';
import { getCurrentYear } from 'site-modules/shared/utils/time-util';
import { Faq } from 'site-modules/shared/components/faq/faq';
import { WRAPPER_TYPES } from 'site-modules/shared/components/faq/constants';
import { LeaseDealsEntities } from 'client/site-modules/lease-deals/constants/prop-types';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';

const FaqEntryUI = memo(
  ({ entry, leaseDealsData = undefined, nearbyInventoryData = undefined, makeName = undefined }) => {
    const dynamicAnswers = getFaqDynamicAnswers({
      leaseDealsData,
      faqEntry: entry,
      nearbyInventoryData,
      make: makeName,
    });
    const entries = entry
      .children()
      .map(e => ({
        question: interpolateTemplate(e.metadata('question').value(), { year: getCurrentYear(), make: makeName }),
        answer:
          dynamicAnswers[e.id] ||
          interpolateTemplate(e.metadata('answer').value(), { year: getCurrentYear(), make: makeName }),
      }))
      .filter(e => e.question && e.answer);

    return (
      <Faq
        title={entry.title}
        entries={entries}
        wrapperType={WRAPPER_TYPES.accordion}
        questionComponent="h3"
        creativeId={entry.metadata('creative-id').value()}
        className="mt-1_5"
      />
    );
  }
);

FaqEntryUI.displayName = 'FaqEntry';
FaqEntryUI.propTypes = {
  entry: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.func.isRequired,
    metadata: PropTypes.func.isRequired,
  }).isRequired,
  leaseDealsData: LeaseDealsEntities.LeaseDealsData,
  nearbyInventoryData: PropTypes.shape({
    inventoryCount: PropTypes.number,
    lowestLease: PropTypes.number,
    highestLease: PropTypes.number,
  }),
  makeName: PropTypes.string,
};

export const FaqEntry = connectToModel(FaqEntryUI, {
  nearbyInventoryData: bindToPath(LeaseDealsPaths.getNearbyMakeInventoryPath(), LeaseDealsModel, null, false),
  makeName: bindToPath(
    LeaseDealsPaths.getRouteFiltersPath(),
    LeaseDealsModel,
    routeFilters => routeFilters?.make ?? null,
    false
  ),
});
